export const getSearchParam = (
    search: string,
    key: string,
    fallback?: string | null
): string | null => {
    const value = new URLSearchParams(search).get(key);
    return value ?? (fallback ?? null);
};

export const getSearchInt = (search: string, key: string, fallback: number): number => {
    const raw = new URLSearchParams(search).get(key);
    const parsed = raw ? parseInt(raw, 10) : Number.NaN;
    return Number.isNaN(parsed) ? fallback : parsed;
};

export const buildReferrer = (pathname: string, search: string): string => {
    return encodeURIComponent(`${pathname}${search}`);
};
